export const mutations = {
  setModeloTanque(state, payload) {
    state.modeloTanque = payload;
  },
  setModelosTanques(state, payload) {
    state.modelosTanques = payload;
  },
  addModeloTanque(state, payload) {
    state.modelosTanques.push(payload);
  },
  removeModeloTanque(state, payload) {
    let index = state.modelosTanques.map((x) => x.id).indexOf(payload.id);
    state.modelosTanques.splice(index, 1);
  },
  setModalCadastroModeloTanque(state, payload) {
    state.modalCadastroModeloTanque = payload;
  },
  setModalExcluirModeloTanque(state, payload) {
    state.modalExcluirModeloTanque = payload;
  },
};

export default {};
